import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageHeader } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { DISPLAY_MODE } from "Constants";
import { useStoreState } from "easy-peasy";
import FourOThree from "Pages/private/403";
import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { GenerateBackPath } from "Utils";
import UserForm from "../components/form";

export default function NewUserPage({ ...props }) {
  const history = useHistory();
  const match = useRouteMatch();

  const [user, setUser] = useState({
    userUnit: null,
    confirmed: true,
    email: null,
    name: "",
    phone: "",
    surname: "",
    locked: false,
  });
  const { abilities } = useStoreState((store) => store.auth);

  return (
    <>
      <PageHeader
        className="customized"
        backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
        onBack={() => {
          history.push(GenerateBackPath(match.path, 4));
        }}
        title={"Yeni Kullanıcı"}
      />
      {AuthCheck(abilities, AUTH_ACTIONS.NEW_RECORD, "Kullanıcı Listesi") ? (
        <UserForm
          mode={DISPLAY_MODE.NEW}
          user={user}
          onAfterSuccess={(response) => {
            history.push(
              `${GenerateBackPath(match.path, 4)}/${response?.id}/detay`
            );
          }}
        />
      ) : (
        <FourOThree />
      )}
    </>
  );
}
